export default __webpack_public_path__ + "static/media/9b.50bd4df0.png";